import { Button } from "@mui/material";
import { useState } from "react";
import UploadParticipantFileModal from "./UploadParticipantFileModal";
import { useDispatch, useSelector } from "react-redux";
import { selectParticipantFilter, setParticipantFilter } from "../../dataWranglerSlice";
import CloseIcon from "@mui/icons-material/Close";

const FilterParticipantsButton = () => {
    const [open, setOpen] = useState<boolean>(false);
    const dispatch = useDispatch();
    const participants = useSelector(selectParticipantFilter);

    const onClick = () => {
        if (participants.length > 0) {
            dispatch(setParticipantFilter([]));
        } else {
            setOpen(true);
        }
    }

    return (
        <>
            <Button
                variant={participants.length > 0 ? "outlined" : "secondary"}
                color={participants.length > 0 ? "success" :  undefined }
                onClick={onClick}
                endIcon={participants.length > 0 ? <CloseIcon /> : undefined}
            >
                {participants.length > 0
                    ? `Filter Applied: ${participants.length} participants`
                    : `FILTER FOR A SUBSET OF PARTICIPANTS`
                }
            </Button>
            <UploadParticipantFileModal open={open} close={() => setOpen(false)} />
        </>
    )
}

export default FilterParticipantsButton;